export default __webpack_public_path__ + "static/media/IMG_1433.4c3282cd.jpg";